const types = {
    SET_LIST: '[KYC MOBILE] SET LIST',
}

export {
    types
}